import {SuggestionDataItem} from "react-mentions";
import {AccessListUser} from "types/AccessListUser";

export function generateMentionables(mentionables: AccessListUser[] | null): SuggestionDataItem[] {
  if (!mentionables) return [];

  return mentionables.map((accessList) => ({id: accessList["@id"], display: accessList.name}))
}